import React, { useRef } from 'react';
import useEscapeKeyDown from './hooks/useEscapeKeyDown';
import * as styles from './Modal.module.scss';
const Modal = ({
  open,
  onClose,
  classname,
  children
}) => {
  useEscapeKeyDown(open, onClose);
  const modalRef = useRef(null);
  if (!open) {
    return null;
  }
  const handleClick = e => {
    if (modalRef.current === e.target) {
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: `${styles.root} ${classname || ''}`,
    onClick: handleClick
  }, children);
};
export default Modal;